let checkNaN = (value) => {
    if ( value == 'Na,NaN' || value == 0 ) {
        return '0,00 zł'
    } else {
        return value + ' zł';
    }
}

export default checkNaN;